import React from 'react';
import InlineEditableElement from 'Components/InlineEditableElement';
import {hoc} from 'Page/Sections/Heading/Heading';

class Heading extends React.Component{

  render(){
    let section = this.props.section;
    return (
      <div className="heading text-center wow fadeInUp" data-wow-duration="1000ms" data-wow-delay="300ms">
        <InlineEditableElement el='h2' {...this.props.inlineEditorProps}
                               fontFamilyChanged={this.props.fontFamilyChanged} className="intro-heading" html={section.prop('title')} onChange={this.props.titleChanged.bind(this)} inlineEditingEnabled={this.props.inlineEditingEnabled}/>
        {typeof section.prop('subtitle') !== 'undefined' || this.props.inlineEditingEnabled ? <InlineEditableElement
          fontFamilyChanged={this.props.fontFamilyChanged} html={section.prop('subtitle')} {...this.props.inlineEditorProps} className="intro-lead-in" onChange={this.props.subtitleChanged.bind(this)} inlineEditingEnabled={this.props.inlineEditingEnabled} /> : null}
      </div>
    );
  }

}

export default hoc(Heading);
